// extracted by mini-css-extract-plugin
export default {"container":"Login_container__BkF0X","wrapper":"Login_wrapper__IQZ9c","avatar":"Login_avatar__vqWvJ","form":"Login_form__bpb3N","hidden":"Login_hidden__wmFvq"};